import {
  GAMECDK_SET_VISIBLE,
  GAMECDK_CREATE_QRCODE,
  GAMECDK_POLLS,
  GAMECDK_CODE_VISIBLE,
  GAMECDK_CODE_GET_DESC,
} from '../constants/gamecdk';

export const gameCdkQRcodeGet = param => ({
  type: GAMECDK_CREATE_QRCODE,
  param,
});

export const gameCdkPollsResult = param => ({
  type: GAMECDK_POLLS,
  param,
});

// 游戏CDK
export const gameCDKSetVisible = param => ({
  type: GAMECDK_SET_VISIBLE,
  param,
});

// 游戏CDK查看展示
export const gameCDKCodeVisible = param => ({
  type: GAMECDK_CODE_VISIBLE,
  param,
});

// 游戏CDK描述
export const gameCDKGetDesc = param => ({
  type: GAMECDK_CODE_GET_DESC,
  param,
});
